import { render, staticRenderFns } from "./EntityVip.vue?vue&type=template&id=31e5728f&scoped=true&"
import script from "./EntityVip.vue?vue&type=script&lang=js&"
export * from "./EntityVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5728f",
  null
  
)

export default component.exports